// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-dc94a268],.btn[data-v-dc94a268]:hover{color:#fff}", "",{"version":3,"sources":["webpack://./resources/js/components/SocialShare.vue"],"names":[],"mappings":"AAAgB,kDAAW,UAAU","sourcesContent":[".btn{color:#fff}.btn:hover{color:#fff}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
